import { WorldUI } from './worldUI';

export class World {
  private ui: WorldUI = new WorldUI();

  public constructor(private render: (data, afterRender: () => void) => {}, public worldData: any) {
    this.ui.onWorldChange(this.handleWorldChange.bind(this));

    if (this.ui.worldListElement.val().toString() !== '') {
      this.ui.worldNameWrapperElement.hide();
    }
  }

  private handleWorldChange(world: string) {
    this.changeWorldData(world);
  }


  private changeWorldData(world: string, flag?: boolean) {
    if ((typeof world === 'undefined' || world === '')) {
      // Start new world
      this.ui.worldNameElement.val('');
      this.ui.worldNameWrapperElement.show();
    } else {
      // Load existing world
      this.ui.worldNameElement.val(world);
      this.ui.worldNameWrapperElement.hide();
    }
  }

}
